const home = {
  heroTitle: '全网磁力网站，一站导航',
  heroSubtitle: '精选优质磁力搜索网站，覆盖影视、软件、游戏、音乐等全品类资源。最新、最快、最稳定的磁力网站导航，让资源查找变得简单高效。',
  heroSearchPlaceholder: '输入关键词搜索磁力网站...',
  heroSearchBtn: '搜索磁力',
  heroHotTags: '热门搜索：',
  categoryTitle: '磁力资源分类导航',
  categoryDesc: '八大资源分类，精准定位你需要的内容，快速找到对应类型的优质磁力网站。',
  featuredTitle: '热门推荐磁力网站',
  featuredDesc: '综合评分最高的磁力搜索网站，经过严格筛选和用户验证，资源丰富、速度稳定。',
  latestTitle: '最新收录磁力网站',
  latestDesc: '持续发现优质磁力新站，第一时间收录到导航中，让你抢先体验新一代磁力搜索服务。',
  statsTitle: '磁力网站大全数据一览',
  statsTotalSites: '收录网站',
  statsCategories: '资源分类',
  statsDailyVisits: '日均访问',
  statsUpdated: '资源更新',
  faqTitle: '常见问题解答',
  faqDesc: '关于磁力链接和磁力网站的常见疑问，这里都有详细解答。',
  ctaTitle: '还没找到想要的磁力网站？',
  ctaDesc: '告诉我们你的需求，我们会持续收录更多优质磁力网站，不断完善导航服务。',
  ctaBtn: '推荐磁力网站',
  rating: '评分',
  speed: '速度',
  stability: '稳定性',
  resources: '资源量',
  visitSite: '访问网站',
  newTag: '新收录',
  hotTag: '热门',
};

export default home;